/* eslint-disable */
export default {
  doNotCall: 'Älä soita',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
